import profileLogoIcon from './logo/profile_icon.png';

type LogoFullProps = {
  className?: string;
};

const LogoIcon = ({ className }: LogoFullProps) => {
  return <img src={profileLogoIcon} className={className} alt="Profile Logo" />;
};

export default LogoIcon;
